<script setup>
import { computed, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';

const props = defineProps({
  searchKey: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['replace']);

const store = useStore();

const cannedMessages = computed(() => store.getters.getCannedResponses || []);

const items = computed(() => {
  return cannedMessages.value.map(cannedMessage => ({
    label: cannedMessage.short_code,
    key: cannedMessage.short_code,
    description: cannedMessage.content,
  }));
});

const fetchCannedResponses = () => {
  store.dispatch('getCannedResponse', { searchKey: props.searchKey });
};

watch(() => props.searchKey, fetchCannedResponses);

onMounted(() => {
  fetchCannedResponses();
});

const handleMentionClick = (item = {}) => {
  emit('replace', item.description);
};
</script>

<template>
  <div>
    <MentionBox
      v-if="items.length"
      :items="items"
      @mention-select="handleMentionClick"
    />
  </div>
</template>
